export default "__VITE_ASSET__DZWUMnZ3__"